export const MAX_COLS = 4;
export const ROWS = 2;

export default {
  MAX_COLS,
  ROWS,
};
